<template>
  <div>
    <tiptap-vuetify
      v-model="content"
      :extensions="extensions"
      placeholder="Add notes for reference"
    >
    </tiptap-vuetify>
  </div>
</template>

<script>
import {
  // component
  TiptapVuetify,
  // extensions
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HorizontalRule,
  History,
  Image
} from 'tiptap-vuetify'

export default {
  name: 'note-input',
  inputType: 'note',
  components: { TiptapVuetify },
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  computed: {
    content: {
      get: function () {
        return this.modelValue[this.value.name]
      },
      set: function (val) {
        this.$emit('update-query-param-value', { name: this.paramName, key: this.value.name, value: val })
      }
    }
  },
  data: () => ({
    extensions: [
      History,
      Blockquote,
      Underline,
      Italic,
      ListItem, // if you need to use a list (BulletList, OrderedList)
      BulletList,
      OrderedList,
      Image,
      [
        Heading,
        {
          // Options that fall into the tiptap's extension
          options: {
            levels: [3]
          }
        }
      ],
      Bold,
      Link,
      Strike,
      Code,
      HorizontalRule
    ]
  })
}
</script>
